import React from "react";

import {Button} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";

import {useOfferPageAmplitudeItemListTrackingContext} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {useFavourites} from "../hooks/use_favourites";
import {useFavouritesAmplitudeEntities} from "../hooks/use_favourites_amplitude_entities";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {AmplitudeFavouritePlacement, IAmplitudeFavouritesEventParams} from "../tracking/get_amplitude_favourites_event_properties";
import {trackAmplitudeAddToFavourites} from "../tracking/track_amplitude_add_to_favourites";
import {trackAmplitudeRemoveFromFavourites} from "../tracking/track_amplitude_remove_from_favourites";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeFavouritePlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement = "rp_favourite_sidebar"} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites, isTreatmentGuest} = useFavourites();
    const {pageLocation} = useOfferPageAmplitudeItemListTrackingContext();
    const {offer, property} = useFavouritesAmplitudeEntities({offerId, propertyId});

    const isInFavourites = isPropertyInFavourites(propertyId);

    const favouritesEventParams: IAmplitudeFavouritesEventParams = {
        location: pageLocation,
        favouritePlacement: amplitudePlacement,
        offer,
        property
    };

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            const wasRemoved = await removePropertyFromFavourites(propertyId);

            if (!wasRemoved) {
                return;
            }

            trackAmplitudeRemoveFromFavourites(favouritesEventParams);
            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            const wasAdded = await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            if (!wasAdded || isTreatmentGuest) {
                return;
            }

            trackAmplitudeAddToFavourites(favouritesEventParams);
            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Button
            variant={isInFavourites ? "filled_secondary" : theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
            size="small"
            iconLeft={HeartIcon}
            onClick={onFavouriteToggle}
            className={className}
        >
            {isInFavourites ? "W ulubionych" : "Dodaj do ulubionych"}
        </Button>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";

import {useOfferPageAmplitudeItemListTrackingContext} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {useFavourites} from "../hooks/use_favourites";
import {useFavouritesAmplitudeEntities} from "../hooks/use_favourites_amplitude_entities";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {AmplitudeFavouritePlacement, IAmplitudeFavouritesEventParams} from "../tracking/get_amplitude_favourites_event_properties";
import {trackAmplitudeAddToFavourites} from "../tracking/track_amplitude_add_to_favourites";
import {trackAmplitudeRemoveFromFavourites} from "../tracking/track_amplitude_remove_from_favourites";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeFavouritePlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement = "rp_favourite_sidebar"} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites, isTreatmentGuest} = useFavourites();
    const {pageLocation} = useOfferPageAmplitudeItemListTrackingContext();
    const {offer, property} = useFavouritesAmplitudeEntities({offerId, propertyId});

    const isInFavourites = isPropertyInFavourites(propertyId);

    const favouritesEventParams: IAmplitudeFavouritesEventParams = {
        location: pageLocation,
        favouritePlacement: amplitudePlacement,
        offer,
        property
    };

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            const wasRemoved = await removePropertyFromFavourites(propertyId);

            if (!wasRemoved) {
                return;
            }

            trackAmplitudeRemoveFromFavourites(favouritesEventParams);
            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            const wasAdded = await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            if (!wasAdded || isTreatmentGuest) {
                return;
            }

            trackAmplitudeAddToFavourites(favouritesEventParams);
            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Button
            variant={isInFavourites ? "filled_secondary" : theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
            size="small"
            iconLeft={HeartIcon}
            onClick={onFavouriteToggle}
            className={className}
        >
            {isInFavourites ? "W ulubionych" : "Dodaj do ulubionych"}
        </Button>
    );
};
